import { Checkbox, IconButton, Stack, styled } from '@ethings/ui-toolkit';
import { FormControlLabel, useTheme } from '@mui/material';
import { ChangeEvent, FC } from 'react';
import { makeStyles } from '../../../theme';
import { testid } from '../../../util';
import { Icon } from '../../icons';
import { OverflowTooltip } from '../../tooltip';

const useStyles = makeStyles()(() => ({
  checkbox: {
    '& .MuiFormControlLabel-label': {
      minWidth: 0,
    },
  },
}));

interface Props {
  checked: boolean;
  disabled?: boolean;
  handleClick: (e: ChangeEvent<HTMLInputElement>) => void;
  handleSubMenuButtonClick?: () => void;
  indeterminate?: boolean;
  label: string;
  showSubMenuButton?: boolean;
  value?: string;
}

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(0.5),
  padding: 0,
}));

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: 0,
  paddingRight: theme.spacing(1),
}));

const StyledFormControlLabel = styled(FormControlLabel)(() => ({
  margin: 0,
  width: '100%',
}));

export const LayerSelectionCheckBox: FC<Props> = ({
  checked,
  disabled,
  handleClick,
  handleSubMenuButtonClick,
  indeterminate,
  label,
  showSubMenuButton = false,
  value,
}) => {
  const theme = useTheme();
  const { classes } = useStyles();

  return (
    <Stack direction="row" justifyContent="space-between" pb={0.5}>
      <StyledFormControlLabel
        data-testid={testid`layer-select-${label}`}
        className={classes.checkbox}
        control={
          <StyledCheckbox
            checked={checked}
            disabled={disabled}
            indeterminate={indeterminate}
            onChange={handleClick}
            size="small"
            value={value}
          />
        }
        label={
          <OverflowTooltip
            sx={{
              whiteSpace: 'nowrap',
              width: '100%',
            }}
          >
            {label}
          </OverflowTooltip>
        }
      />
      {
        showSubMenuButton
        && <StyledIconButton data-testid="chevron-right-button" disabled={disabled} onClick={handleSubMenuButtonClick}>
          <Icon data-testid="chevron-right-icon" icon="ChevronRight" style={{ color: disabled ? undefined : theme.palette.common.black }} />
        </StyledIconButton>
      }
    </Stack >
  );
};
